<template>
  <div style="background: #f7f7f8; padding: 20px 0">
    <div class="content-center">
      <div class="title">条款及条件</div>
      <div class="p">
        本人同意该软件（定义如下）的安装、其运作及有关服务（定义如下）将受下列条款及条件管限。<br />
        1)释义 a. 在本条款及条件中，除文意另有所指外，以下词句应作以下解释： i.<br />
        “货拉拉”或“依时货拉拉”指在中国境内成立的服务中心； ii.<br />
        “参与面包车”及“参与货车”分别指与“货拉拉”达成协议，接受阁下通过“货拉拉”提供有关服务下达订单并按订单内容提供服务之面包车及货车；<br />
        iii. “有关服务”指第3(a)段中列明的服务； iv.<br />
        “该软件“指与本条款及条件有关的 “货拉拉”程序； v.<br />
        “本条款及条件“指根据第8(a)段不时修改的，本条款与条件； vi.<br />
        “广告”指该软件运作时会在阁下移动终端出现的推广讯息。 b.<br />
        本条款与条件列出“货拉拉”与阁下之间有关使用该软件及有关服务的完整协议。<br />
        2)该软件的特许使用权 a.<br />
        阁下获准安装一套该软件到阁下的移动终端中作个人用途，但阁下不得将该软件及有关服务用作任何商业用途。<br />
        b.<br />
        阁下不得出租、租借、再特许使用、分发或转让该软件的拷贝或将使用该软件的特许使用权给予任何第三方。<br />
        c.<br />
        阁下不得更改、改写、进行逆向工程、反编译、解体、翻译该软件及以该软件为基础创作衍生作品。<br />
        d. 阁下不得危及本软件的正常运作，或以其他方式试图导出其源代码的软件; e.<br />
        阁下不得上传或发放任何形式的病毒、蠕虫、木马、恶意代码; f.<br />
        除运行被“货拉拉”认可的操作系统之移动终端设备，阁下不得在任何其他设备安装及/或执行该软件。<br />
        g.<br />
        除在第2(a)段下授予的许可外，本条款及条件并不授予阁下任何其他许可或权利。“货拉拉”及其供货商特此保留该软件的拥有权及所有其他权利。<br />
        3)服务 a.<br />
        “货拉拉”提供的有关服务包括向参与面包车及参与货车发放阁下透过该软件向“货拉拉”提交的个人资料以及提出之面包车及货车行程的详情，以供参与面包车及参与货车接收、选择，亦包括向阁下提供其他有关参与面包车及参与货车，行程以及阁下使用的有关服务的数据。<br />
        b.
        “货拉拉”仅为阁下及参与面包车、货车提供中立、独立、免费的第三方信息中介服务。阁下同意及承认“货拉拉”并非阁下的代理或参与面包车及参与货车的代理，亦非雇用参与面包车车及参与货车之合约的任何一方。
        c.<br />
        阁下须妥善保管“货拉拉”就有关该软件及有关服务向阁下提供的任何用户名称及密码，并不能向第三方披露。<br />
        d.<br />
        阁下应妥善保管移动终端设备、用户名称及密码，“货拉拉”将默认任何使用阁下的移动终端、用户名称及密码的人士将会是阁下本人或阁下之授权人士。<br />
        4) 费用 免费提供有关服务予阁下。 5) 连结及广告 a.<br />
        “货拉拉”将尽力保证广告的真实性与准确性； b.<br />
        “货拉拉”提醒阁下注意：在接受广告时，请务必仔细询问广告主发布的广告的详情以及时效性。<br />
        6) 责任条款 a.<br />
        该软件是以“现状”形式传送予阁下，虽然“货拉拉”已尽其最大努力去确保该软件在阁下的移动终端中能运作正常，但“货拉拉”并不保证该软件的性能以及该软件与阁下的移动终端的兼容性。<br />
        b.<br />
        “货拉拉”将尽力保证有关服务的供应、透过使用有关服务所得之面包车及货车供应、<br />
        作为有关服务一部份所提供的数据及数据的准确性、或参与面包车及参与货车提供的服务的质素。<br />
        c.<br />
        阁下需特别注意：在“货拉拉”提供服务信息后，阁下需对服务提供方进行适当的审查义务，并作出是否接受服务之决定。阁下需按照《中华人民共和国合同法》之规定对标的物进行适当包装以方便服务提供方提供服务并在法律范围内承担整个服务过程中的法律责任。<br />
        d.<br />
        阁下需重点注意：根据中国大陆法律法规，阁下的标的物不得有禁运品。如有危险品，需提前告知服务提供方以及“货拉拉”，且“货拉拉”及服务提供方有权拒绝提供服务。<br />
        7) 数据私隐 a.<br />
        阁下有需要向“货拉拉”提供个人资料以促使使用该软件的若干功能。阁下同意“货拉拉”可使用阁下在使用该软件之时向“货拉拉”不时提供的个人资料（即阁下的名字及联络电话），作提供有关服务之用途。<br />
        b.<br />
        阁下同意“货拉拉”在为阁下提供有关服务时按所需的程度及时间而有权收集、使用、保留及更新阁下的个人资料，而阁下确认阁下提供的个人资料是真实及正确而且为最新近的。<br />
        c.<br />
        阁下进一步明确同意“货拉拉”有权在有需要情况下将阁下的个人资料转交给参与面包车及参与货车，上述有需要情况包括但不限于为阁下寻找接受预约之面包车及货车之时，面包车及货车司机与阁下确认/澄清预约资料，及当“货拉拉”提供有关服务予阁下而需追踪已预约面包车及货车之时。<br />
        d.<br />
        阁下进一步同意有关阁下个人资料的收集、使用、储存及转交一般受到“货拉拉”的私隐政策及个人资料采集声明所限制，其最新版本刊载于<br />
        “Huolala.cn”，而阁下必须在同意本条款及条件前阅读并明白上述政策及声明。<br />
        8) 杂项 a.<br />
        “货拉拉”可不时修改本条款及条件，修改方式将透过“Huolala.cn”，“货拉拉”在完成修改后将尽力通过各种手段提请阁下注意并及时查看最新条款。<br />
        b. 本条款及条件受中华人民共和国法律管辖并据其予以解释。 9) 使用守则 a.<br />
        阁下不得使用“货拉拉”进行或推广任何非法活动; b.<br />
        阁下不得使用“货拉拉”产生电子邮件广告或垃圾邮件; c.<br />
        阁下不得使用“货拉拉”跟踪、骚扰或伤害另一个人; d.<br />
        阁下不得以任何方式干扰“货拉拉”的正常运作或破坏连接到 “货拉拉”的服务器或<br />
        网络，或违反连接到“货拉拉”的网络要求、程序、政策或法规; e.<br />
        阁下不得冒充任何人使用“货拉拉”。 10) 优惠<br />
        “货拉拉”将会不时提供优惠给阁下，<br />
        除非另有说明，“货拉拉”将向阁下声明优惠券的使用期限，阁下必须在声明的期限内使用，否则将产生优惠券过期无法使用的法律后果。<br />
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.content-center {
  width: 1080px;
  margin: 0 auto;
  background: #fff;
  .title {
    font-size: 16px;
    font-weight: 400;
    color: #2f3439;
    line-height: 18px;
    padding: 20px 42px;
    position: relative;
    border-bottom: 1px solid #f3f3f3;
  }
  .title::before {
    content: "";
    width: 2px;
    height: 13px;
    background: #f16622;
    position: absolute;
    top: 22px;
    left: 22px;
  }
  .p {
    font-size: 12px;
    color: #768191;
    line-height: 18px;
    padding: 15px 22px;
  }
}
</style>